import { useContext, useEffect, useState } from "react";
import { ReactComponent as eventIcon } from '../../../../icons/event.svg';
import 'react-datepicker/dist/react-datepicker.css';
import './../krFormView.scss';
import { DatepickerFieldProps } from "../../../../components/datepickerField/types/datepickerFieldProps";
import DatepickerField from "../../../../components/datepickerField/datepickerField";
import { configValidation, createConfigValidation, validation } from "../../../../helpers/validation/validation";
import KrFormContext, { KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes, NavHeadingsKROEnum, NavHeadingsKRTZEum } from "../../../../contexts/krFormContext";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { ObjectType } from "../../../../contexts/types/card";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict, KRTZFieldDict } from "../../shared/commentsSidebar/fieldDict";

const DeterminationDate = (props: FormSectionProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext);
    const [configValidationDate, setConfigValidationDate] = useState<configValidation>({});
    const [errorTipText, setErrorTipText] = useState<string | null>();
    const [firstRenderMarker, setFirstRenderMarker] = useState(false);

    // Validation 
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            var errorMsg = krForm.config?.ValidationError!["datA_USTALENIA"]
            if (errorMsg !== '') {
                const completeDate = getAttributes(krForm)?.datA_WYPELNIENIA;
                setConfigValidationDate(createConfigValidation("datA_USTALENIA", false, completeDate, props.version));
                setErrorTipText(errorMsg);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    useEffect(() => {
        if (firstRenderMarker) {
            const determinedDate = getAttributes(krForm)?.datA_USTALENIA;
            const completeDate = getAttributes(krForm)?.datA_WYPELNIENIA;
            var configValidation = createConfigValidation("datA_USTALENIA", false, completeDate, props.version);
            setConfigValidationDate(configValidation);
            setErrorTipText(validation(configValidation, determinedDate))
        }
        if (!firstRenderMarker) setFirstRenderMarker(true);

        // @ts-ignore
        // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [krForm.landslideAttributes?.datA_USTALENIA, krForm.landslideAttributes?.datA_WYPELNIENIA, krForm.endangeredAreaAttributes?.datA_USTALENIA, krForm.endangeredAreaAttributes?.datA_WYPELNIENIA])

    const onChangeDeterminationDate = (event: Date) => {
        var form: any = Object.assign({}, krForm);
        const attributes = getAttributes(form);
        if (form !== null && attributes) {
            if(event){
                event.setHours(12, 0, 0, 0);
            }
            event ? attributes.datA_USTALENIA = event.getTime() : attributes.datA_USTALENIA = null;
        }
        setkrForm(form);
    }

    const getAttributes = (form: krFormTypes) => {
        return props.objectType === ObjectType.KRO ? (form as KrLandslideFormTypes).landslideAttributes : (form as KrEndangeredAreaFormTypes).endangeredAreaAttributes;
    }

    const prepareSelected = () => {
        const attributes = getAttributes(krForm);
        return attributes?.datA_USTALENIA ? new Date(new Date(attributes?.datA_USTALENIA).setHours(12, 0, 0, 0)) : attributes?.datA_USTALENIA;
    }

    // Determination date
    const determinationDateKRFieldDict = props.objectType === ObjectType.KRO ? KROFieldDict.dataUst_dataUstalenia : KRTZFieldDict.dataUst_dataUstalenia;
    var datepickerFieldPropsDeterminationDate: DatepickerFieldProps = {
        dateFormat: "yyyy-MM-dd",
        selected: prepareSelected(),
        shouldCloseOnSelect: false,
        fixedHeight: true,
        inputPlaceholder: "Wybierz datę",
        labelName: 'Data ustalenia',
        style: styleFormFieldHalf,
        configValidation: configValidationDate,
        additionalIcon: eventIcon,
        setValue: onChangeDeterminationDate,
        datepickerSharedProps: {
            className: 'datepicker'
        },
        validationError: errorTipText != null,
        tipText: errorTipText ? errorTipText : undefined,
        pristine: true,
        disabled: !props.editMode,
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, determinationDateKRFieldDict, 'Data ustalenia', props.setNewCommentFieldDetails!),
        inputRef: (node: any) => {getFieldRef(node, determinationDateKRFieldDict, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(determinationDateKRFieldDict); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === determinationDateKRFieldDict
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, props.objectType === ObjectType.KRO ? NavHeadingsKROEnum.DeterminationDate : NavHeadingsKRTZEum.DeterminationDate, props.getMapForNavScroll!)}
                style={{ width: '100%' }}>{`${props.objectType === ObjectType.KRTZ ? 8 : 21}. Data ustalenia`}</h2>
            <DatepickerField {...datepickerFieldPropsDeterminationDate} />
        </>
    )
}

export default DeterminationDate;